import React from 'react';
import { TITLE_LIST_OF_ROUTE } from '../../config/constant/language';

export default function ListRoute() {
  return <div>{TITLE_LIST_OF_ROUTE}</div>;
}
